/** Seleção em chips (filtros, cortes de KPI, papéis). */
export default function ChipGroup<T extends string>({ options, value, onChange, multiple }: {
  options: { value: T; label: string }[];
  value: T | T[];
  onChange: (v: any) => void;
  multiple?: boolean;
}) {
  const isSel = (v: T) => (Array.isArray(value) ? value.includes(v) : value === v);
  return (
    <div className="chips">
      {options.map((o) => (
        <button
          key={o.value}
          type="button"
          aria-pressed={isSel(o.value)}
          className={`chip ${isSel(o.value) ? 'sel' : ''}`}
          onClick={() => {
            if (!multiple) return onChange(o.value);
            const cur = value as T[];
            onChange(cur.includes(o.value) ? cur.filter((x) => x !== o.value) : [...cur, o.value]);
          }}
        >
          {o.label}
        </button>
      ))}
    </div>
  );
}
